import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      reviews: "Reviews",
      contact: "Contact",
      bookAppointment: "Book Appointment",
      callUs: "Call Us",
    },
    hero: {
      subtitle: "EXPERT MDS DENTAL SPECIALISTS IN SECUNDERABAD",
      title: "Advanced Care for Your Healthy, Confident Smile",
      desc: "Led by MDS specialists Dr. Sai Krishna Kalva & Dr. Thejasri Keerthipati, providing compassionate, painless, and modern dental treatments tailored for you.",
      bookButton: "Book Your Appointment",
      callButton: "Call Clinic",
      card1Title: "Patient Education",
      card1Desc: "Clear guides on oral health and treatment steps.",
      card1Button: "View Care Guides →",
      card2Title: "Patient Reviews",
      card2Desc: "See what local patients say about our clinic.",
      card2Button: "Read Reviews →",
    },
    about: {
      welcome: "Welcome to Dr. Krishna's Dental",
      heading: "Meet your trusted dentists in",
      location: "Secunderabad.",
      desc: "Led by MDS specialists Dr. Sai Krishna Kalva and Dr. Thejasri Keerthipati, our clinic combines cutting-edge dental technology with a warm, patient-first approach. We believe dental visits shouldn't be stressful, and we take time to design personalized treatment protocols that fit your lifestyle.",
      drSaiTitle: "Oral & Maxillofacial Surgeon",
      drSaiDesc1: "As an MDS Specialist in Oral & Maxillofacial Surgery, Dr. Sai Krishna brings specialized hospital training to every routine and complex procedure. He specializes in advanced implantology, wisdom teeth extractions, and corrective jaw surgeries with surgical precision.",
      drSaiDesc2: "No rushed appointments or generic plans. He takes the time to explain your treatment path and ensures you feel completely at ease.",
      drSaiButton: "Book with Dr. Sai",
      drTejaTitle: "Orthodontist & Smile Specialist",
      drTejaDesc1: "As an MDS Specialist in Orthodontics, Dr. Thejasri is dedicated to creating beautiful, aligned smiles using modern braces and clear aligners tailored to each patient's facial profile.",
      drTejaDesc2: "Her patient-first philosophy ensures gentle, customized orthodontic care for both children and adults in a comforting environment.",
      drTejaButton: "Book with Dr. Thejasri",
    },
    services: {
      tag: "SERVICES",
      heading: "Care Designed Around Your Smile Goals",
      desc: "We offer a full range of services designed to improve your oral health, confidence, and quality of life:",
      learnMore: "Learn More",
      exploreAll: "Explore All Our Services",
    },
    reviews: {
      tag: "TESTIMONIALS",
      heading: "What Patients Are Saying About Us",
      desc: "Patients consistently choose Dr. Krishna's Dental for care that feels different—in the best way.",
      note: "We're proud to build lasting relationships with patients who trust us with their smiles.",
      button: "Review us on Google",
    },
    location: {
      heading: "Conveniently Located in Secunderabad",
      desc1: "Our clinic is conveniently located at First Floor, Dammaiguda Road, Nagaram, making it easily accessible for patients from anywhere across Secunderabad and Hyderabad.",
      desc2: "Whether you're coming from work, home, or nearby neighborhoods, our central location and ample parking make it simple to fit quality dental care into your routine.",
      servingText: "We proudly serve patients from:",
    },
    cta: {
      heading: "Your Next Step Toward a Healthier, More Confident Smile",
      subtext: "Finding the right dentist can make all the difference. At Dr. Krishna's Dental, we're here to provide care that feels comfortable, personalized, and built around you.",
      bookNow: "Book Now",
    },
    footer: {
      addressLabel: "Address:",
      phoneLabel: "Phone:",
      timingLabel: "Timing:",
      timings: "All Days: 10:00 AM – 9:00 PM",
      practiceHeading: "Our Practice",
      servicesHeading: "Services",
      copyright: "All rights reserved.",
    },
    contactPage: {
      breadcrumbHome: "Home",
      breadcrumbContact: "Contact Us",
      tagline: "Get in Touch",
      title: "Contact Dr. Krishna's Dental",
      subtitle: "We're here to answer your questions, schedule your consultation, and help you take the next step toward a healthy smile.",
      formHeading: "How Can We Help?",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone Number",
      email: "Email Address",
      message: "Message",
      sendButton: "Send Message",
      sendingButton: "Sending...",
      visitTitle: "Visit Our Secunderabad Office",
      officeHours: "Office Hours",
    },
  },
  te: {
    nav: {
      home: "హోమ్",
      about: "మా గురించి",
      services: "సేవలు",
      reviews: "అభిప్రాయాలు",
      contact: "సంప్రదించండి",
      bookAppointment: "అపాయింట్‌మెంట్ బుక్ చేయండి",
      callUs: "కాల్ చేయండి",
    },
    hero: {
      subtitle: "సికింద్రాబాద్‌లో నిపుణులైన MDS దంత వైద్యులు",
      title: "మీ ఆరోగ్యకరమైన, అందమైన నవ్వు కోసం అత్యాధునిక వైద్యం",
      desc: "MDS స్పెషలిస్ట్‌లు డాక్టర్ సాయి కృష్ణ కల్వ & డాక్టర్ తేజశ్రీ కీర్తిపాటి ఆధ్వర్యంలో, నొప్పుల్లేని మరియు ఆధునిక దంత సంరక్షణ సేవలు అందించబడును.",
      bookButton: "అపాయింట్‌మెంట్ బుక్ చేసుకోండి",
      callButton: "క్లినిక్‌కి కాల్ చేయండి",
      card1Title: "రోగులకు దంత సమాచారం",
      card1Desc: "దంత ఆరోగ్యం మరియు సంరక్షణ చిట్కాలు.",
      card1Button: "వివరాలు చూడండి →",
      card2Title: "రోగుల అనుభవాలు",
      card2Desc: "మా వద్ద వైద్యం పొందిన వారి సమీక్షలు.",
      card2Button: "రివ్యూలు చూడండి →",
    },
    about: {
      welcome: "డాక్టర్ కృష్ణ డెంటల్‌కి సుస్వాగతం",
      heading: "మీ నమ్మకమైన దంత వైద్యులను కలవండి -",
      location: "సికింద్రాబాద్.",
      desc: "MDS స్పెషలిస్ట్‌లు డాక్టర్ సాయి కృష్ణ మరియు డాక్టర్ తేజశ్రీ ఆధ్వర్యంలో, మా క్లినిక్ అత్యాధునిక దంత సాంకేతిక పరిజ్ఞానంతో రోగుల సంక్షేమానికి ప్రాధాన్యత ఇస్తుంది.",
      drSaiTitle: "ఓరల్ & మ్యాక్సిల్లోఫేషియల్ సర్జన్",
      drSaiDesc1: "డాక్టర్ సాయి కృష్ణ గారు దంత ఇంప్లాంట్లు, జ్ఞాన దంతాల చికిత్స (Wisdom Teeth Removal) మరియు దవడ సర్జరీలలో ప్రత్యేక అనుభవం కలిగిన నిపుణులు.",
      drSaiDesc2: "రోగులకు చికిత్స విధానాన్ని స్పష్టంగా వివరించి, ఎంతో ప్రేమతో, నొప్పుల్లేకుండా వైద్యం అందిస్తారు.",
      drSaiButton: "డాక్టర్ సాయి గారిని సంప్రదించండి",
      drTejaTitle: "ఆర్థోడాంటిస్ట్ & స్మైల్ స్పెషలిస్ట్",
      drTejaDesc1: "డాక్టర్ తేజశ్రీ గారు దంతాల వరుస సరిచేయడం (Braces & Clear Aligners) మరియు పిల్లల దంత సంరక్షణలో నిపుణురాలు.",
      drTejaDesc2: "పిల్లలకు మరియు పెద్దలకు ఎంతో సున్నితంగా, సురక్షితమైన ఆర్థోడాంటిక్ చికిత్సను అందిస్తారు.",
      drTejaButton: "డాక్టర్ తేజశ్రీ గారిని సంప్రదించండి",
    },
    services: {
      tag: "సేవలు",
      heading: "మీ దంత ఆరోగ్యానికి కావలసిన సంపూర్ణ చికిత్సలు",
      desc: "మీ దంత ఆరోగ్యం మరియు అందమైన నవ్వు కోసం మేము అందించే సేవలు:",
      learnMore: "మరిన్ని వివరాలు",
      exploreAll: "అన్ని సేవలను చూడండి",
    },
    reviews: {
      tag: "రోగుల అభిప్రాయాలు",
      heading: "మా వద్ద చికిత్స పొందిన రోగులు ఏమంటున్నారు",
      desc: "ఉత్తమమైన దంత వైద్యం కోసం ప్రజలు నమ్మకంతో డాక్టర్ కృష్ణ డెంటల్‌ను ఎంచుకుంటారు.",
      note: "మాపై నమ్మకం ఉంచిన రోగులకు సేవ చేయడం మాకు ఎంతో గర్వకారణం.",
      button: "గూగుల్‌లో రివ్యూ చూడండి",
    },
    location: {
      heading: "సికింద్రాబాద్‌లో సులభంగా అందుబాటులో ఉన్నాము",
      desc1: "మా క్లినిక్ దమ్మాయిగూడ రోడ్, నాగారంలో ప్రధాన రహదారిపై ఉంది. సికింద్రాబాద్ మరియు పరిసర ప్రాంతాల వారికి సులభంగా అందుబాటులో ఉంటుంది.",
      desc2: "విశాలమైన పార్కింగ్ సదుపాయం మరియు ఆహ్లాదకరమైన వాతావరణం కలదు.",
      servingText: "ఈ పరిసర ప్రాంతాల ప్రజలకు మేము సేవలు అందిస్తున్నాము:",
    },
    cta: {
      heading: "ఆరోగ్యకరమైన, మరింత నమ్మకమైన నవ్వు దిశగా మీ తదుపరి అడుగు",
      subtext: "సరైన దంత వైద్యుడిని ఎంచుకోవడం చాలా ముఖ్యం. డాక్టర్ కృష్ణ డెంటల్‌లో మీకు పూర్తి సౌకర్యవంతమైన దంత సంరక్షణ లభిస్తుంది.",
      bookNow: "ఇప్పుడే బుక్ చేయండి",
    },
    footer: {
      addressLabel: "చిరునామా:",
      phoneLabel: "ఫోన్:",
      timingLabel: "సమయాలు:",
      timings: "అన్ని రోజులు: ఉదయం 10:00 - రాత్రి 9:00",
      practiceHeading: "మా క్లినిక్",
      servicesHeading: "సేవలు",
      copyright: "అన్ని హక్కులూ ప్రత్యేకించబడినవి.",
    },
    contactPage: {
      breadcrumbHome: "హోమ్",
      breadcrumbContact: "సంప్రదించండి",
      tagline: "మమ్మల్ని సంప్రదించండి",
      title: "డాక్టర్ కృష్ణ డెంటల్‌కి స్వాగతం",
      subtitle: "మీ సలహాలు, సంశయాలు నివృత్తి చేయడానికి మరియు అపాయింట్‌మెంట్ బుక్ చేయడానికి మేము సిద్ధంగా ఉన్నాము.",
      formHeading: "మేము మీకు ఏ విధంగా సహాయపడగలము?",
      firstName: "మొదటి పేరు",
      lastName: "చివరి పేరు",
      phone: "ఫోన్ నంబర్",
      email: "ఈమెయిల్ అడ్రస్",
      message: "మీ సందేశం",
      sendButton: "సందేశం పంపండి",
      sendingButton: "పంపుతోంది...",
      visitTitle: "మా సికింద్రాబాద్ క్లినిక్‌ని దర్శించండి",
      officeHours: "క్లినిక్ సమయాలు",
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("app_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("app_lang", lang);
  }, [lang]);

  const toggleLanguage = () => {
    setLang((prev) => (prev === "en" ? "te" : "en"));
  };

  const t = translations[lang] || translations.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
